import FieldWithLabel from '@src/components/FieldWithLabel';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'theme-ui';

type contentProps = {
  vm: any;
  lessonCount: number;
  setLessonCount: any;
  lessonFor: any;
  setLessonFor: any;
  selectedSubject: any;
  setSelectedSubject: any;
  lessonGrades: any;
  setLessonGrades: any;
  selectedGrade: any;
  setSelectedGrade: any;
  lessonTopic: any;
  setLessonTopic: any;
  isSubjectInvalid: any;
  isGradeInvalid: any;
  isTopicInvalid: any;
  discountOptions: any;
  setIsSubjectInvalid: any;
};
function bookALessonContent({
  vm,
  lessonCount,
  setLessonCount,
  lessonFor,
  setLessonFor,
  selectedSubject,
  setSelectedSubject,
  lessonGrades,
  setLessonGrades,
  selectedGrade,
  setSelectedGrade,
  lessonTopic,
  setLessonTopic,
  isSubjectInvalid,
  isGradeInvalid,
  isTopicInvalid,
  discountOptions,
  setIsSubjectInvalid,
}: contentProps) {
  const { t } = useTranslation();
  return (
    <Box>
      {vm.lessonForUsers && vm.lessonForUsers.length > 0 && (
        <Box sx={{ margin: '24px 0' }}>
          <FieldWithLabel
            sx={{ minWidth: '200px' }}
            label={t('lessonFor')}
            isSelect
            value={lessonFor}
            onChange={(e) => {
              setLessonFor(e.target.value);
            }}
          >
            <option value="" key="" selected>
              {t('lessonForMe')}
            </option>
            {vm.lessonForUsers.map(({ id, firstName, lastName }) => (
              <option value={id} key={id}>
                {firstName} {lastName}
              </option>
            ))}
          </FieldWithLabel>
        </Box>
      )}
      <Box
        sx={{
          marginBottom: '24px',
          fontSize: '20px',
        }}
      >
        <Box>
          <div style={{ margin: '10px 0 5px 0' }}>{t('lessonCount')}</div>
          <Box
            sx={{
              width: '225px',
              '@media screen and (max-width: 52em)': {
                width: '100%',
              },
              height: '60px',
              display: 'flex',
              backgroundColor: 'primaryPale',
              padding: '17px 10px',
              justifyContent: 'space-between',
              borderRadius: '5px',
              gap: '10px',
            }}
          >
            <div
              style={{
                width: '29px',
                height: '29px',
                backgroundColor: 'white',
                textAlign: 'center',
                borderRadius: '50%',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
              onClick={() => {
                lessonCount > 1 ? setLessonCount(lessonCount - 1) : null;
              }}
            >
              -
            </div>
            <div style={{ textAlign: 'center' }}>{lessonCount}</div>
            <div
              style={{
                width: '29px',
                height: '29px',
                backgroundColor: 'white',
                textAlign: 'center',
                borderRadius: '50%',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
              onClick={() => {
                lessonCount === 30 ? null : setLessonCount(lessonCount + 1);
              }}
            >
              +
            </div>
          </Box>
        </Box>

        <Box>
          <div style={{ margin: '10px 0 5px 0' }}>{t('discount')}</div>
          <div style={{ display: 'flex', gap: '5px', flexWrap: 'wrap' }}>
            {discountOptions.map((item, index) => {
              const lastRedItem = [...discountOptions]
                .reverse()
                .find((item) => lessonCount >= item.count);
              return (
                <div
                  onClick={() => setLessonCount(item.count)}
                  key={index}
                  style={{
                    fontWeight: 'bold',
                    flex: item.discount === 15 ? 2 : 1,
                    textAlign: 'center',
                    borderRadius: '14px',
                    background: item.bigBoxBackground,
                    display: 'flex',
                    flexDirection: 'column',
                    height: item.discount === 15 ? '91px' : '81px',
                    border:
                      lastRedItem?.count === item.count
                        ? '2px solid #000000'
                        : '',
                  }}
                >
                  <Box
                    sx={{
                      fontSize: '16px',
                      height: '100%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      '@media screen and (max-width: 52em)': {
                        fontSize: '12px',
                      },
                    }}
                  >
                    {item.count} {t('lessonShort')}
                  </Box>
                  <Box
                    sx={{
                      height: item.discount === 15 ? '53px' : '47px',
                      margin: '2px 1px',
                      fontSize: '20px',
                      borderRadius: '12px',
                      padding: '5px 10px',
                      background: item.smallBoxBackground,
                      '@media screen and (max-width: 52em)': {
                        fontSize: '18px',
                      },
                    }}
                  >
                    <div>
                      {' '}
                      {item.discount ? '-' : ''}
                      {item.discount}%{' '}
                    </div>
                    {item.message && (
                      <div
                        style={{
                          fontSize: '10px',
                          textTransform: 'uppercase',
                        }}
                      >
                        {item.message}
                      </div>
                    )}
                  </Box>
                </div>
              );
            })}
          </div>
        </Box>
      </Box>

      <Flex
        sx={{
          gap: '10px',
          '@media screen and (max-width: 52em)': {
            flexDirection: 'column',
          },
        }}
      >
        {vm.teacherSubjects && (
          <Box sx={{ marginBottom: '24px', flex: '1' }}>
            <FieldWithLabel
              sx={{ fontFamily: 'Roboto' }}
              label={t('subject')}
              isSelect
              value={selectedSubject}
              onChange={(e) => {
                const value = e.target.value;
                setSelectedSubject(value);
                const subject = vm.teacherSubjects.find(
                  (item) => item.value === value
                );
                setLessonGrades(subject?.grades || []);
                setSelectedGrade('');
              }}
              error={isSubjectInvalid}
            >
              {vm.teacherSubjects?.length > 1 && (
                <option value="" key="default" selected />
              )}
              {vm.teacherSubjects.map(({ label, value }) => (
                <option value={value} key={label}>
                  {label}
                </option>
              ))}
            </FieldWithLabel>
          </Box>
        )}
        <Box
          sx={{
            marginBottom: '24px',
            opacity: lessonCount > 0 ? '1' : '0.3',
            pointerEvents: lessonCount > 0 ? 'auto' : 'none',
            flex: '1',
          }}
        >
          <FieldWithLabel
            sx={{ fontFamily: 'Roboto' }}
            label={t('lessonClass')}
            isSelect
            onClick={() => {
              if (selectedSubject === '') {
                setIsSubjectInvalid(true);
              }
            }}
            value={selectedGrade}
            onChange={(e) => {
              const value = e.target.value;
              setSelectedGrade(value);
            }}
            error={isGradeInvalid}
          >
            <option value="" key="default" selected />
            {lessonGrades.map((item) => (
              <option value={item} key={item}>
                {item}
              </option>
            ))}
          </FieldWithLabel>
        </Box>
      </Flex>

      <Box
        sx={{
          marginBottom: '24px',
        }}
      >
        <FieldWithLabel
          id="lessonTopic"
          fontFamily={'Roboto'}
          label={lessonCount > 1 ? t('firstLessonTopic') : t('lessonTopic')}
          onChange={(e) => {
            setLessonTopic(e.target.value);
          }}
          error={isTopicInvalid}
          value={lessonTopic}
        />
      </Box>
    </Box>
  );
}

export default bookALessonContent;
